/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateLocationResponse
 */
export interface CreateLocationResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateLocationResponse
     */
    id: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateLocationResponse interface.
 */
export function instanceOfCreateLocationResponse(value: object): value is CreateLocationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateLocationResponseFromJSON(json: any): CreateLocationResponse {
    return CreateLocationResponseFromJSONTyped(json, false);
}

export function CreateLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
    };
}

export function CreateLocationResponseToJSON(json: any): CreateLocationResponse {
    return CreateLocationResponseToJSONTyped(json, false);
}

export function CreateLocationResponseToJSONTyped(value?: CreateLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
    };
}

